import type { CropVarietyConfigurationsByKey } from "../types.js";

export const tayberryVarietyConfigurations = {
    "tayberry.buckingham": { crop: "tayberry", aliases: [], isExample: false, customName: false },
    "tayberry.medana": { crop: "tayberry", aliases: [], isExample: false, customName: false },
    "tayberry.custom": { crop: "tayberry", aliases: [], isExample: false, customName: true },
} as const satisfies CropVarietyConfigurationsByKey;
